<template>
  <div>
    <site-header></site-header>
    <div class="c-t-request">
      <transition name="o-transition--fade" mode="out-in">
        <div class="c-t-request__main" v-if="!loading && !error" key="content">
          <request-header :request="request" :openModal="openModal"></request-header>

          <!-- <section-notice v-if="!contractRequested && request.IsOwner && request.SecureJob" :text="'Här ser du vilka företag som besvarat din förfrågan. Vill du gå vidare med en hantverkare till avtal går du in på “Be om avtalsförslag” ovan. Du får ett digitalt avtalsförslag skickat till dig på mail från din utvalda hantverkare.'" /> -->

          <contract v-if="contract && contract.IsContractor" :contract="contract" />

          <section-interested-companies
            v-if="request.Companies && request.Companies.length > 0"
            :companies="request.Companies"
            :text="contractExplaination"
          ></section-interested-companies>
          <section-information :request="request"></section-information>
          <section-gallery v-if="showGallery" :request="request"></section-gallery>

          <section-map :address="request.Address" :region="request.Region" />
        </div>
        <div class="c-t-request__main" v-else-if="loading && !error" key="loading">
          <loader class="c-m-loader--x-large" />
        </div>
        <div class="c-t-request__main" v-else key="error-1">
          <error-state v-bind="errorStateContent" hideIcon></error-state>
        </div>
      </transition>
    </div>
    <site-footer></site-footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  FETCH_REQUEST_BY_ID,
  FETCH_REQUEST_ANSWER,
  GET_REQUEST,
  IS_LOADING,
  GET_ERROR
} from "../store/store-models/request-model";
import { IS_AUTHENTICATED } from "../store/store-models/authentication-model";
import { 
    FETCH_CONTRACT_FOR_REQUEST,
    GET_CONTRACT,
    GET_IS_CONTRACT_REQUESTED
} from "../store/store-models/contract-model";

import Icon from "./components/atoms/AtomIcon.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import RequestHeader from "./components/organisms/request-sections/OrganismRequestHeader.vue";
import Loader from "./components/molecules/MoleculeLoader.vue";
import ErrorState from "./components/molecules/MoleculeErrorState.vue";
import SectionInformation from "./components/organisms/request-sections/OrganismRequestSectionInformation.vue";
import SectionGallery from "./components/organisms/request-sections/OrganismRequestSectionGallery.vue";
import SectionInterestedCompanies from "./components/organisms/request-sections/OrganismRequestSectionInterestedCompanies.vue";
import SectionMap from "./components/organisms/request-sections/OrganismRequestMap.vue";
import SectionNotice from "./components/atoms/SectionNoticeBox.vue";
import Contract from "./components/organisms/request-sections/OrganismContract.vue";

export default {
  async asyncData({ store, route }) {
    const { id } = route.params;
    const { query = {} } = route;

    if (store.getters[IS_AUTHENTICATED]) {
      await store.dispatch(FETCH_REQUEST_ANSWER, id);
      await store.dispatch(FETCH_CONTRACT_FOR_REQUEST, id);
    }
    return store.dispatch(FETCH_REQUEST_BY_ID, { id, query });
  },
  props: ["openModal"],
  components: {
    SiteHeader,
    SiteFooter,
    RequestHeader,
    SectionInformation,
    SectionGallery,
    Icon,
    Loader,
    ErrorState,
    SectionInterestedCompanies,
    SectionMap,
    Contract,
    SectionNotice
  },
  computed: {
    ...mapGetters({
      request: GET_REQUEST,
      isAuthenticated: IS_AUTHENTICATED,
      contract: GET_CONTRACT,
      contractRequested: GET_IS_CONTRACT_REQUESTED,
    }),
    contractExplaination: function(){
      if(!this.contractRequested && this.request.IsOwner && this.request.SecureJob){        
        return 'Här ser du vilka företag som besvarat din förfrågan. Vill du gå vidare med en hantverkare till avtal går du in på “Be om avtalsförslag” ovan. Du får ett digitalt avtalsförslag skickat till dig på mail från din utvalda hantverkare.';
      }
      return null;
    },
    showGallery: function() {
      return (
        (this.request.Images && this.request.Images.length > 0) ||
        (this.request.Files && this.request.Files.length > 0)
      );
    },
    loading: function() {
      return this.$store.getters[IS_LOADING]("request");
    },
    error: function() {
      return this.$store.getters[GET_ERROR]("request");
    },
    bcTitle: function() {
      if (!this.isLoading && !this.error) {
        return this.request.Title ? this.request.Title : "Förfrågan";
      } else if (this.isLoading && !this.error) {
        return "Laddar...";
      } else {
        return "Fel";
      }
    },
    metaContent: function() {
      if (!this.isLoading && !this.error) {
        return this.request.Title
          ? `${this.request.Title} är en av alla förfrågningar som gjorts hos oss. Hitta rätt företag för just ditt uppdrag du också.`
          : "Detta är en av alla förfrågningar som gjorts hos oss. Hitta rätt företag för just ditt uppdrag du också.";
      } else if (this.isLoading && !this.error) {
        return "Laddar...";
      } else {
        return "Förfrågan kunde inte hittas. Den kan ha raderats eller så kan länken du följde vara felaktig. Om problemet kvarstår, kontakta gärna vår kundtjänst.";
      }
    },
    errorStateContent: function() {
      let content = {
        heading: 'Sidan kunde inte hittas',
        body: '<p>Länken till sidan du försöker hämta fungerar inte.</p>',
        button: {
          label: "Till startsidan",
          icon: "home",
          classes: "c-a-button--theme-primary",
          to: "/"
        }
      };

      if (this.error.status === 404) {
        content = {
          ...content,
          heading: "Förfrågan kunde inte hittas",
          body:
            '<p>Den kan ha raderats eller så kan länken du följde vara felaktig.</p><p>Om problemet kvarstår kan du kontakta kundtjänst på <a href="mailto:info@brabyggare.se">info@brabyggare.se</a></p>'
        };
      }

      return content;
    }
  },
  methods: {
    ...mapActions({
      fetchRequest: FETCH_REQUEST_BY_ID,
      fetchRequestAnswer: FETCH_REQUEST_ANSWER,
      fetcContract: FETCH_CONTRACT_FOR_REQUEST
    })
  },
  metaData() {
    return {
      title: this.bcTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaContent
        }
      ],
      link: [
        {
          rel: "canonical",
          href: `${process.env.SITE_BASE_URL}${this.$route.path}`
        }
      ]
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Request.vue